export default __webpack_public_path__ + "static/img/Letinte63.5b58ebb.jpg";